import { useState, useEffect } from 'react';
import logo from '../assets/logo.png';

export default function useTransparentLogo() {
  const [src, setSrc] = useState(logo);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      // 1. Dibujar imagen original
      const canvas = document.createElement('canvas');
      canvas.width  = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);

      // 2. Quitar píxeles blancos/casi-blancos
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const d = imageData.data;
      for (let i = 0; i < d.length; i += 4) {
        if (d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240) {
          d[i + 3] = 0;
        }
      }
      ctx.putImageData(imageData, 0, 0);

      // 3. Calcular bounding box del contenido visible
      let minX = canvas.width, minY = canvas.height, maxX = 0, maxY = 0;
      for (let i = 0; i < d.length; i += 4) {
        if (d[i + 3] > 0) {
          const x = (i / 4) % canvas.width;
          const y = Math.floor((i / 4) / canvas.width);
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }

      // 4. Recortar al contenido real (+ 4px de margen)
      const pad = 4;
      minX = Math.max(0, minX - pad);
      minY = Math.max(0, minY - pad);
      maxX = Math.min(canvas.width  - 1, maxX + pad);
      maxY = Math.min(canvas.height - 1, maxY + pad);
      const cw = maxX - minX + 1;
      const ch = maxY - minY + 1;

      const cropped = document.createElement('canvas');
      cropped.width  = cw;
      cropped.height = ch;
      cropped.getContext('2d').drawImage(canvas, minX, minY, cw, ch, 0, 0, cw, ch);

      setSrc(cropped.toDataURL('image/png'));
    };
    img.src = logo;
  }, []);

  return src;
}
